'use strict';

require('../../style/index.less');

require('./index.less');

require('../../grid/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/form/style/index.tsx
 ** module id = 770
 ** module chunks = 0
 **/